import React, { useState, useEffect } from 'react';
import cardUtils from '../../utils/cardUtils';
import shoppingCart from '../../utils/shoppingCart';
import CardPrice from './CardPrice';

const CardPriceList = props => {
  const [stores, setStores] = useState([]);

  useEffect(() => {
    setStores(shoppingCart.getStores());
  }, []);

  return (
    <>
      {stores.length && (
        <div className="flex flex-col gap-y-2">
          {cardUtils.sortPrices(props.prices).map(price => (
            <CardPrice
              key={price.id}
              card={props.card}
              price={price}
              addToCart={true}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default CardPriceList;
